const _ = require('lodash');

import UserCentricViewController from './usercentrics-view-controller';
import { SettingsService } from '../../services/settings-service';
import { StyleService } from '../../services/style-service';
import { UtilityService } from '../../services/utility.service';
import { CustomEmbedService } from '../../services/utilities/custom-embed.service';
import Constants from '../../constants';
import { ConsentsStatusService } from '../../services/consents-services/consents-status.service';
import { DataService } from '../../services/utilities/data.service';

let scope: any;
export class MainViewController {
    private settingsService: SettingsService;
    private styleService: StyleService;
    private utilityService: UtilityService;
    userCentricViewController: UserCentricViewController;

    private usercentricsDiv: any = document.createElement('div');

    constructor(styleService, utilityService) {
        scope = this;
        this.settingsService = utilityService.settingsService;
        this.styleService = styleService;
        this.utilityService = utilityService;

        this.userCentricViewController = new UserCentricViewController(
            MainViewController.update,
            this.utilityService
        );
        this.utilityService.UserCentricViewController = this.userCentricViewController;

		/** 
		 * @dave please put this part of the code at the right place before removing comments.
		 * window["usercentrics"]["updateView"] = (layout: any) => {
		 * let settings: any = _.cloneDeep(this.settingsService.settings);
		 * settings.layout = layout;
		 * this.settingsService.settings = settings;
		 * this.usercentricsDiv.className =
		 * "usercentrics-button " +
		 * this.settingsService.settings.layout +
		 * " uc-button-" +
		 * this.settingsService.settings.buttonDisplayLocation;
		 * this.usercentricsDiv.innerHTML =
		 * this.userCentricViewController.htmlString;
		 * this.userCentricViewController = new UserCentricViewController(
		 *  this.update,
		 * this.settingsService,
		 * this.utilityService,
		 * );
		 * let self = this;
		 * setTimeout(function() {
		 * self.initView();
		 * });
		 * };
		 */
    }

    public initView() {
        setTimeout(function () {
            // self.styleService.styles = self.settingsService.settings.styles;
            CustomEmbedService.injectCurrentDate();
            if (document.readyState === 'complete') {
                scope.utilityService.developmentLog(
                    'readystate is already complete so load directly',
                    document.readyState
                );
                scope.utilityService.customEmbedService.injectTemplateOnHost();
            } else {
                document.addEventListener('readystatechange', () => {
                    scope.utilityService.developmentLog(
                        'readystatechange',
                        document.readyState
                    );
                    if (document.readyState === 'complete') {
                        scope.utilityService.customEmbedService.injectTemplateOnHost();
                    }
                });
            }
        });
        if (
            window.self !== window.top &&
            !scope.settingsService.settings.isVisibleInIframe
        ) {
            return;
        }
        this.utilityService.developmentLog(
            'main view controller is initializing view...'
        );
        this.usercentricsDiv.setAttribute('id', 'usercentrics-button');
        this.usercentricsDiv.className =
            'usercentrics-button ' +
            this.settingsService.settings.layout +
            ' uc-button-' +
            this.settingsService.settings.buttonDisplayLocation +
            ' uc-banner-' +
            this.settingsService.settings.bannerPlacement +
            ' uc-modal-' +
            this.settingsService.settings.cornerModalPlacement +
            (this.settingsService.settings.privacyButtonIsVisible
                ? ''
                : ' uc-button-hidden') +
            ' injected-styles';

        // If the "eu only" setting is active, fetch location of user and determine if ui should be shown
        if (this.utilityService.settingsService.settings.displayOnlyForEU) {

            // location was not yet loaded
            if (this.utilityService.isEUUser === undefined) {
                this.utilityService.apiService.getClientLocation().then(response => {
                    this.utilityService.isEUUser = Constants.EU_COUNTRIES.indexOf(response.countryCode) !== -1;
                    this.utilityService.isConsentChangeAllow = this.utilityService.isEUUser;

                    // In case use is from outside EU, accept all consents and make it essential
                    if (!this.utilityService.isEUUser) {
                        const action = 'onNonEURegion';
                        const updatedBy = 'implicit';
                        this.utilityService.settingsService.acceptCookiesAgreement(action, updatedBy);
                        ConsentsStatusService.setAllCategoriesToEssential(DataService.categories);
                    }

                    // Show HTML based of result of api all
                    this.appendDisplay(scope, this.utilityService.isEUUser);
                })
                    .catch((e) => {
                        console.log(e);
                    });
            } else {
                // location was loaded
                this.appendDisplay(scope, this.utilityService.isEUUser);
            }
        } else {
            // show HTML, do not alter visibilities
            this.appendDisplay(scope, true);
        }
    }

    /**
     * Injects the HTML into the page. Optionally hides all the ui elements
     * @param scope 
     * @param displayHTML False to hide all UI elements
     */
    public appendDisplay(scope, displayHTML) {
        if (!displayHTML) {
            this.userCentricViewController.privacyCornerModal.visible = false;
            this.utilityService.UserCentricViewController.consentsInfoModal.visible = false;
            this.userCentricViewController.privacyCenterModal.visible = false;
            this.settingsService.bannerIsVisible = false;
            this.settingsService.chipIsVisible = false;
            this.settingsService.privacyButtonIsVisible = false;
        }
        this.usercentricsDiv.innerHTML = this.userCentricViewController.htmlString;
        if (!document.body) {
            this.utilityService.developmentLog('Body not ready, use event listener for appendDisplay');
            document.addEventListener('DOMContentLoaded', () => {
                this.utilityService.developmentLog('Appending usercentricsDiv after DOMContentLoaded');
                document.body.appendChild(this.usercentricsDiv);
                setTimeout(function () {
                    scope.styleService.styles = scope.settingsService.settings.styles;
                    scope.userCentricViewController.initHandling();
                    CustomEmbedService.injectCurrentDate();
                    scope.utilityService.onViewInit();
                });
            });
        } else {
            document.body.appendChild(this.usercentricsDiv);
            setTimeout(function () {
                scope.styleService.styles = scope.settingsService.settings.styles;
                scope.userCentricViewController.initHandling();
                CustomEmbedService.injectCurrentDate();
                scope.utilityService.onViewInit();
            });
        }
    }

    public static update() {
        if (
            window.self === window.top ||
            scope.settingsService.settings.isVisibleInIframe
        ) {
            scope.utilityService.developmentLog(
                'main view controller is reinitializing whole view...'
            );

            setTimeout(function () {
                scope.usercentricsDiv.innerHTML =
                    scope.userCentricViewController.htmlString;

                // Make the following updates asynchronously to prevent IE 11 from crashing
                setTimeout(function () {
                    scope.utilityService.developmentLog('whole innerHTML is updated');
                    scope.styleService.styles = scope.settingsService.settings.styles;
                    scope.userCentricViewController.initHandling();
                    scope.utilityService.onUpdateView();
                }, 20);
            });
        }
        setTimeout(function () {
            CustomEmbedService.injectCurrentDate();
            scope.utilityService.customEmbedService.injectTemplateOnHost();
        });
    }
}
